import { Flex, Label, Text } from '@approvalmax/ui/src/components';
import { XeroIconSmall } from 'modules/sprites';
import { memo } from 'react';
import { InfoCard } from 'shared/components';

import { messages } from './FinancialDetails.messages';
import { FinancialDetailsProps } from './FinancialDetails.types';

export const FinancialDetails = memo<FinancialDetailsProps>((props) => {
    const { data } = props;

    const { bankAccountName, bankAccountNumber, reference, currency, sortCode } = data;

    return (
        <InfoCard
            title={
                <Text font='headline' fontSize='xxsmall' fontWeight='medium' color='midnight70'>
                    {messages.title}
                </Text>
            }
            color='midnight20'
            beforeTitle={<XeroIconSmall />}
        >
            <Flex spacing='16' justifyContent='space-between'>
                {bankAccountName && (
                    <div>
                        <Label>{messages.bankAccountName}</Label>

                        <Text font='label' fontSize='small' color='midnight70'>
                            {bankAccountName}
                        </Text>
                    </div>
                )}

                {sortCode && (
                    <div>
                        <Label>{messages.sortCode}</Label>

                        <Text font='label' fontSize='small' color='midnight70'>
                            {sortCode}
                        </Text>
                    </div>
                )}

                {bankAccountNumber && (
                    <div>
                        <Label>{messages.bankAccountNumber}</Label>

                        <Text font='label' fontSize='small' color='midnight70'>
                            {bankAccountNumber}
                        </Text>
                    </div>
                )}

                {reference && (
                    <div>
                        <Label>{messages.reference}</Label>

                        <Text font='label' fontSize='small' color='midnight70'>
                            {reference}
                        </Text>
                    </div>
                )}

                {currency && (
                    <div>
                        <Label>{messages.currency}</Label>

                        <Text font='label' fontSize='small' color='midnight70'>
                            {currency}
                        </Text>
                    </div>
                )}
            </Flex>
        </InfoCard>
    );
});

FinancialDetails.displayName = 'FinancialDetails';
